import {environment} from "../../../../environments/environment";

export class ApiConfig {
  public static baseApiUrl = environment.baseApiUrl;
  public static auth = environment.baseApiUrl + '/oauth2';
  public static login = ApiConfig.auth + '/token';

  public static mbankAuth = environment.baseApiUrl + '/oauth';
  public static mbankLogin = ApiConfig.mbankAuth + '/token';

  public static VERIFY_OTP = ApiConfig.auth + '/verify-otp';
  public static refreshToken = ApiConfig.auth + '/refresh';
  public static baseApiEndPoint = environment.baseApiUrl + '/v1';
  public static baseApiEndPointV2 = environment.baseApiUrl + '/v2';

  public static TFA_METHODS = ApiConfig.baseApiEndPoint + '/2fa/public/get-verification-methods';
  public static TFA_GENERATE_CODE = ApiConfig.baseApiEndPoint + '/2fa/public/generate-verification-code';

  public static externalApiEndPoint = environment.baseApiUrl + '/v2/api';
  public static imageUrl = environment.baseApiUrl;

  // potential problem oAuth or oAuth2??
  public static TOKEN = environment.baseApiUrl + '/oauth/token';

}
